import { useState, useEffect } from "react";

// ui
import {
  Button,
  Typography,
  Modal,
  Box,
  Paper,
  FormControl,
  TextField,
  FormHelperText,
  Select,
  MenuItem,
  Checkbox,
} from "@mui/material";
import { styled } from "@mui/system";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

// InterFace
import { useWindowSize } from "../lib/useWindowSize";
import { LIST_POST, LIST } from "../config/const";

// API
import { getTossUpAddForm } from "../api/tossUp";
import { getAddress } from "../api/address";
import {
  getPresignedPostPicture,
  postPresignedPost,
} from "../api/presignedURL";

const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px", // ここでフォントサイズを指定
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};

interface InputFreeTextProps {
  addData: {
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "toss_up"
      | "success"
      | "failed";
    category_id_list: number[];
    product_name_list: string[];
    phone_number: string;
    customer_name: string;
    customer_list_id: string;
    hope_call_date: string;
    hope_call_time_kind: number | null;
    hope_call_time: string;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  };
  setAddData: React.Dispatch<
    React.SetStateAction<{
      addStatus:
        | null
        | "loading"
        | "change_account"
        | "product"
        | "toss_up"
        | "success"
        | "failed";
      category_id_list: number[];
      product_name_list: string[];
      phone_number: string;
      customer_name: string;
      customer_list_id: string;
      hope_call_date: string;
      hope_call_time_kind: number | null;
      hope_call_time: string;
      customerInfo: { [key: string]: string | string[] };
      changeAccount: 0 | 1;
      changeAccountID: number | null;
    }>
  >;
  uniqueOption: { [key: string]: string | number | string[] };
  addressOptionName: string;
}

function InputFreeText(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  return (
    <>
      <CustomTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        size="small"
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = e.target.value;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
          }));
        }}
        sx={{
          width: "calc(100% - 10px)",
          margin: "10px 5px",
        }}
        multiline={uniqueOption.multi_text_flg === 1}
        rows={uniqueOption.multi_text_flg === 1 ? 4 : undefined}
      />
      {uniqueOption.change_value_conf !== 1 ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            marginRight: "5px",
            height: "25px",
          }}
        >
          {uniqueOption.required_optional === 1 ? "※必須" : "※任意"}
        </FormHelperText>
      ) : null}
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextHalfWidthNumber(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption } = props;
  return (
    <>
      <CustomTextField
        disabled={uniqueOption.change_value_conf === 1}
        id="textFieldId"
        size="small"
        value={addData.customerInfo[uniqueOption.option_name as string]}
        onChange={async (e) => {
          const inputValue = e.target.value;
          if (!/^\d*$/.test(inputValue)) return;
          let customerInfo = addData.customerInfo;
          customerInfo[uniqueOption.option_name as string] = inputValue;
          setAddData((addData) => ({
            ...addData,
            customerInfo,
          }));
        }}
        inputProps={{ inputMode: "numeric", pattern: "\\d*" }}
        sx={{
          width: "calc(100% - 10px)",
          margin: "10px 5px",
        }}
      />
      {uniqueOption.change_value_conf !== 1 ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            marginRight: "5px",
            height: "25px",
          }}
        >
          {uniqueOption.required_optional === 1 ? "※必須" : "※任意"}
        </FormHelperText>
      ) : null}
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextTel(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      input3 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 3
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] =
        input1 + "-" + input2 + "-" + input3;
      const phone_number = input1 + "-" + input2 + "-" + input3;
      setAddData((addData) => ({
        ...addData,
        phone_number,
        customerInfo,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <>
      <Box style={{ display: "flex" }}>
        <CustomTextField
          id="textFieldIdTel1"
          size="small"
          value={input1}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput1(inputValue);
            }
          }}
          sx={{
            width: "calc(33% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "10px", textAlign: "center", marginTop: "12px" }}>
          -
        </Box>
        <CustomTextField
          id="textFieldIdTel2"
          size="small"
          value={input2}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput2(inputValue);
            }
          }}
          sx={{
            width: "calc(33% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "10px", textAlign: "center", marginTop: "12px" }}>
          -
        </Box>
        <CustomTextField
          id="textFieldIdTel3"
          size="small"
          value={input3}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput3(inputValue);
            }
          }}
          sx={{
            width: "calc(33% - 10px)",
            margin: "10px 5px",
          }}
        />
      </Box>
      <FormHelperText
        id="serch-name"
        sx={{
          width: "calc(100% - 10px)",
          textAlign: "right",
          marginTop: "-8px",
          marginRight: "5px",
          height: "25px",
        }}
      >
        {uniqueOption.required_optional === 1 ? "※必須" : "※任意"}
      </FormHelperText>
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextFormTel(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      input3 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 3
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
      setInput3(parts[2]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] =
        input1 + "-" + input2 + "-" + input3;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2, input3]);
  return (
    <>
      <Box style={{ display: "flex" }}>
        <CustomTextField
          id="textFieldIdTel1"
          size="small"
          value={input1}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput1(inputValue);
            }
          }}
          sx={{
            width: "calc(33% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "10px", textAlign: "center", marginTop: "12px" }}>
          -
        </Box>
        <CustomTextField
          id="textFieldIdTel2"
          size="small"
          value={input2}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput2(inputValue);
            }
          }}
          sx={{
            width: "calc(33% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "10px", textAlign: "center", marginTop: "12px" }}>
          -
        </Box>
        <CustomTextField
          id="textFieldIdTel3"
          size="small"
          value={input3}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue)) {
              setInput3(inputValue);
            }
          }}
          sx={{
            width: "calc(33% - 10px)",
            margin: "10px 5px",
          }}
        />
      </Box>
      <FormHelperText
        id="serch-name"
        sx={{
          width: "calc(100% - 10px)",
          textAlign: "right",
          marginTop: "-8px",
          marginRight: "5px",
          height: "25px",
        }}
      >
        {uniqueOption.required_optional === 1 ? "※必須" : "※任意"}
      </FormHelperText>
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextName(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split(" ");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + " " + input2;
      const customer_name = input1 + " " + input2;
      setAddData((addData) => ({
        ...addData,
        customer_name,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <Box style={{ display: "flex" }}>
        <CustomTextField
          id="textFieldIdName1"
          size="small"
          value={input1}
          onChange={async (e) => setInput1(e.target.value)}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "5px" }} />
        <CustomTextField
          id="textFieldIdName2"
          size="small"
          value={input2}
          onChange={async (e) => setInput2(e.target.value)}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
      </Box>
      <FormHelperText
        id="serch-name"
        sx={{
          width: "calc(100% - 10px)",
          textAlign: "right",
          marginTop: "-8px",
          marginRight: "5px",
          height: "25px",
        }}
      >
        {uniqueOption.required_optional === 1 ? "※必須" : "※任意"}
      </FormHelperText>
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextZipCode(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    async function getAddressText(zipCode: string) {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = zipCode;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));

      const address = await getAddress(zipCode);
      customerInfo[addressOptionName] = address;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("-");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      const zipCode = input1 + "-" + input2;
      if (input1.length === 3 && input2.length === 4) {
        getAddressText(zipCode);
      } else {
        let customerInfo = addData.customerInfo;
        customerInfo[uniqueOption.option_name as string] = zipCode;
        setAddData((addData) => ({
          ...addData,
          customerInfo,
        }));
      }
    }
  }, [input1, input2]);
  return (
    <>
      <Box style={{ display: "flex" }}>
        <CustomTextField
          id="textFieldIdZipCode1"
          size="small"
          value={input1}
          inputProps={{ maxLength: 3 }}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue) && inputValue.length <= 3) {
              setInput1(inputValue);
            }
          }}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "10px", textAlign: "center", marginTop: "12px" }}>
          -
        </Box>
        <CustomTextField
          id="textFieldIdZipCode2"
          size="small"
          value={input2}
          inputProps={{ maxLength: 4 }}
          onChange={async (e) => {
            const inputValue = e.target.value;
            if (/^\d*$/.test(inputValue) && inputValue.length <= 4) {
              setInput2(inputValue);
            }
          }}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
      </Box>
      <FormHelperText
        id="serch-name"
        sx={{
          width: "calc(100% - 10px)",
          textAlign: "right",
          marginTop: "-8px",
          marginRight: "5px",
          height: "25px",
        }}
      >
        {uniqueOption.required_optional === 1 ? "※必須" : "※任意"}
      </FormHelperText>
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextSpace(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split(" ");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + " " + input2;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <Box style={{ display: "flex" }}>
        <CustomTextField
          id="textFieldIdSpace1"
          size="small"
          value={input1}
          onChange={async (e) => setInput1(e.target.value)}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "5px" }} />
        <CustomTextField
          id="textFieldIdSpace2"
          size="small"
          value={input2}
          onChange={async (e) => setInput2(e.target.value)}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
      </Box>
      <FormHelperText
        id="serch-name"
        sx={{
          width: "calc(100% - 10px)",
          textAlign: "right",
          marginTop: "-8px",
          marginRight: "5px",
          height: "25px",
        }}
      >
        {uniqueOption.required_optional === 1 ? "※必須" : "※任意"}
      </FormHelperText>
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

function InputFreeTextMailAddress(props: InputFreeTextProps) {
  const { addData, setAddData, uniqueOption, addressOptionName } = props;
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  useEffect(() => {
    if (
      input1 == "" &&
      input2 == "" &&
      addData.customerInfo[uniqueOption.option_name as string] &&
      addData.customerInfo[uniqueOption.option_name as string] != "" &&
      addData.customerInfo[uniqueOption.option_name as string].length !== 2
    ) {
      const option_value = addData.customerInfo[
        uniqueOption.option_name as string
      ] as string;
      const parts = option_value.split("@");
      setInput1(parts[0]);
      setInput2(parts[1]);
    } else {
      let customerInfo = addData.customerInfo;
      customerInfo[uniqueOption.option_name as string] = input1 + "@" + input2;
      setAddData((addData) => ({
        ...addData,
        customerInfo,
      }));
    }
  }, [input1, input2]);
  return (
    <>
      <Box style={{ display: "flex" }}>
        <CustomTextField
          id="textFieldIdmm1"
          size="small"
          value={input1}
          onChange={async (e) => setInput1(e.target.value)}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
        <Box style={{ width: "10px", textAlign: "center", marginTop: "12px" }}>
          @
        </Box>
        <CustomTextField
          id="textFieldIdmm2"
          size="small"
          value={input2}
          onChange={async (e) => setInput2(e.target.value)}
          sx={{
            width: "calc(50% - 10px)",
            margin: "10px 5px",
          }}
        />
      </Box>
      <FormHelperText
        id="serch-name"
        sx={{
          width: "calc(100% - 10px)",
          textAlign: "right",
          marginTop: "-8px",
          marginRight: "5px",
          height: "25px",
        }}
      >
        {uniqueOption.required_optional === 1 ? "※必須" : "※任意"}
      </FormHelperText>
      {uniqueOption.option_comment !== "" ? (
        <FormHelperText
          id="serch-name"
          sx={{
            width: "calc(100% - 10px)",
            textAlign: "right",
            marginTop: "-8px",
            height: "25px",
          }}
        >
          {uniqueOption.option_comment}
        </FormHelperText>
      ) : null}
    </>
  );
}

interface TossUpAddModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  postAddData: (customerInfo: { [key: string]: string | string[] }) => void;
  addData: {
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "toss_up"
      | "success"
      | "failed";
    category_id_list: number[];
    product_name_list: string[];
    phone_number: string;
    customer_name: string;
    customer_list_id: string;
    hope_call_date: string;
    hope_call_time_kind: number | null;
    hope_call_time: string;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  };
  setAddData: React.Dispatch<
    React.SetStateAction<{
      addStatus:
        | null
        | "loading"
        | "change_account"
        | "product"
        | "toss_up"
        | "success"
        | "failed";
      category_id_list: number[];
      product_name_list: string[];
      phone_number: string;
      customer_name: string;
      customer_list_id: string;
      hope_call_date: string;
      hope_call_time_kind: number | null;
      hope_call_time: string;
      customerInfo: { [key: string]: string | string[] };
      changeAccount: 0 | 1;
      changeAccountID: number | null;
    }>
  >;
  uniqueOptinList: { [key: string]: string | number | string[] }[];
  setUniqueOptinList: (
    value: { [key: string]: string | number | string[] }[],
  ) => void;
  addressOptionName: string;
  setAddressOptionName: (name: string) => void;
  postPictures: {
    [key: string]: File;
  };
  setPostPicture: (value: { [key: string]: File }) => void;
  tossUpCategoryNameList: {
    category_id: number;
    category_name: string;
  }[];
  tossUpProductNameList: {
    category_id: number;
    category_name: string;
    product_name: string;
  }[];
  setOnDataAddModalResult: (value: string) => void;
}

export function TossUpAddModal(props: TossUpAddModalProps) {
  const {
    onModal,
    swCloseModal,
    postAddData,
    addData,
    setAddData,
    uniqueOptinList,
    setUniqueOptinList,
    addressOptionName,
    setAddressOptionName,
    postPictures,
    setPostPicture,
    tossUpCategoryNameList,
    tossUpProductNameList,
    setOnDataAddModalResult,
  } = props;
  const { windowWidth, windowHeight } = useWindowSize();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 868 ? "800px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  async function getFormInfo() {
    setAddData((addData) => ({
      ...addData,
      addStatus: "loading",
    }));
    const { option_data } = await getTossUpAddForm(
      addData.category_id_list,
      addData.product_name_list,
      addData.changeAccount,
      addData.changeAccountID,
    );
    setUniqueOptinList(option_data);
    if (option_data.length > 0) {
      const customerInfo: {
        [key: string]: string | string[];
      } = option_data.reduce<{ [key: string]: string | string[] }>(
        (column, option) => {
          let option_value: string | string[] = "";
          if (option.option_type === 0) {
            option_value = option.option_default_value as string;
            return {
              ...column,
              [option.option_name as string]: option_value,
            };
          } else if (option.option_type === 1 || option.option_type === 4) {
            return {
              ...column,
              [option.option_name as string]: "",
            };
          } else if (option.option_type === 3) {
            return {
              ...column,
              [option.option_name as string]: "",
            };
          } else {
            return {
              ...column,
              [option.option_name as string]: [],
            };
          }
        },
        {},
      );
      let addressOptionName = "";
      option_data.map((uniqueOptin) => {
        if (uniqueOptin.address_flg) {
          addressOptionName = uniqueOptin.option_name as string;
        }
      });
      setAddressOptionName(addressOptionName);
      setAddData((addData) => ({
        ...addData,
        customerInfo,
        addStatus: "toss_up",
      }));
    } else {
      swCloseModal();
      setOnDataAddModalResult(
        "トスアップフォームが定義されていません。管理者に問い合わせてください。",
      );
    }
  }

  const [onPostBottun, setOnPostBottun] = useState(false);
  useEffect(() => {
    if (addData.addStatus !== null && addData.addStatus !== "loading") {
      let onPostBottun = true;
      if (addData.hope_call_date === "") {
        onPostBottun = false;
      }
      if (addData.hope_call_time_kind === null) {
        onPostBottun = false;
      }
      if (addData.hope_call_time_kind === 1 && addData.hope_call_time === "") {
        onPostBottun = false;
      }
      uniqueOptinList.map((uniqueOptin) => {
        const product_names = uniqueOptin.product_names as string[];
        const depend_option_name = uniqueOptin.depend_option_name as string;
        const depend_select_names = uniqueOptin.depend_select_names as string[];
        const depend_option_value = addData.customerInfo[depend_option_name];
        if (
          uniqueOptin.required_optional === 1 &&
          (product_names.length === 0 ||
            product_names.some((item) =>
              addData.product_name_list.includes(item),
            )) &&
          (depend_option_name === "他質問に依存しない" ||
            (typeof depend_option_value === "string" &&
              depend_select_names.includes(depend_option_value as string)) ||
            (typeof depend_option_value === "object" &&
              depend_select_names.some((item) =>
                depend_option_value.includes(item),
              )))
        ) {
          if (
            uniqueOptin.option_type === 0 ||
            uniqueOptin.option_type === 1 ||
            uniqueOptin.option_type === 3
          ) {
            const customerInfoValue = addData.customerInfo[
              uniqueOptin.option_name as string
            ] as string;
            if (
              customerInfoValue === undefined ||
              customerInfoValue === "" ||
              customerInfoValue === " " ||
              customerInfoValue === "--"
            ) {
              onPostBottun = false;
            }
          } else if (uniqueOptin.option_type === 2) {
            const customerInfoValue = addData.customerInfo[
              uniqueOptin.option_name as string
            ] as string[];
            if (customerInfoValue.length === 0) {
              onPostBottun = false;
            }
          } else if (uniqueOptin.option_type === 4) {
            if (!postPictures[uniqueOptin.option_name as string]) {
              onPostBottun = false;
            }
          }
        }
      });
      setOnPostBottun(onPostBottun);
    }
  }, [addData, postPictures]);

  // 契約登録前に画像データ格納
  async function postAddTossUpData() {
    setAddData((addData) => ({
      ...addData,
      addStatus: "loading",
    }));
    let customerInfo = { ...addData.customerInfo };
    await Promise.all(
      uniqueOptinList.map(async (uniqueOption) => {
        if (
          uniqueOption.option_type === 4 &&
          postPictures[uniqueOption.option_name as string]
        ) {
          const postPicture = postPictures[uniqueOption.option_name as string];
          // 著名付きURL(post用)を作成
          const fileName = postPicture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(nowTimeName, fileName);

          // POSTする form に持たせるデータを生成する
          const formData = new FormData();
          for (const key in presigned_object.fields) {
            formData.append(key, presigned_object.fields[key]);
          }
          formData.append("file", postPicture);
          // ファイルをS3にアップロード
          await postPresignedPost(presigned_object.url, formData);
          customerInfo[uniqueOption.option_name as string] = destination_key;
        }
      }),
    );
    await postAddData(customerInfo);
  }

  return addData.addStatus !== null && addData.addStatus !== "loading" ? (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} key="TossUpAddModalBox" data-testid="tossup-add-modal">
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="serchTitleBox"
          className="shippori-antique-regular"
        >
          トスアップ
        </Box>
        {addData.addStatus === "product" ? (
          <Typography
            id="modal-modal-description"
            sx={{
              mt: 0,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 50px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
            key="TossUpAddModalBoxProject"
          >
            <Paper elevation={0}>
              <Box
                key="shozai1"
                sx={{
                  maxHeight:
                    windowWidth > 385 ? "calc(70vh - 100px)" : undefined,
                  overflowY: windowWidth > 385 ? "auto" : undefined,
                }}
              >
                <Box key="shozaiClick">
                  {tossUpCategoryNameList.map((categoryName, category_i) => {
                    function categoryDisabled(category_id: number) {
                      let categoryDisabled = false;
                      tossUpProductNameList.map((productName) => {
                        if (
                          addData.product_name_list.includes(
                            productName.product_name,
                          ) &&
                          category_id === productName.category_id
                        ) {
                          categoryDisabled = true;
                        }
                      });
                      return categoryDisabled;
                    }
                    return (
                      <>
                        <Box
                          key={"category_name_" + category_i}
                          className="serch-label"
                          sx={{ marginRight: "25px", marginTop: "15px" }}
                        >
                          <Checkbox
                            checked={addData.category_id_list.includes(
                              categoryName.category_id,
                            )}
                            disabled={
                              categoryDisabled(categoryName.category_id)
                                ? true
                                : false
                            }
                            onClick={() => {
                              let _category_id_list =
                                addData.category_id_list.concat();
                              let _product_name_list =
                                addData.product_name_list.concat();
                              if (
                                addData.category_id_list.includes(
                                  categoryName.category_id,
                                )
                              ) {
                                _category_id_list = _category_id_list.filter(
                                  (category_id) =>
                                    category_id !== categoryName.category_id,
                                );
                              } else {
                                _category_id_list.push(
                                  categoryName.category_id,
                                );
                                tossUpProductNameList.map((tossUpProduct) => {
                                  if (
                                    tossUpProduct.category_id ===
                                    categoryName.category_id
                                  ) {
                                    _product_name_list.push(
                                      tossUpProduct.product_name,
                                    );
                                  }
                                });
                              }
                              setAddData((addData) => ({
                                ...addData,
                                category_id_list: _category_id_list,
                                product_name_list: _product_name_list,
                              }));
                            }}
                            sx={{
                              "& .MuiSvgIcon-root": { fontSize: 16 },
                              marginTop: "-2px",
                            }}
                          />
                          {categoryName.category_name}
                        </Box>
                        {tossUpProductNameList.map((productName, product_i) => {
                          if (
                            categoryName.category_name ===
                            productName.category_name
                          ) {
                            return (
                              <Box
                                key={
                                  "category_product_name_" +
                                  category_i +
                                  "_" +
                                  product_i
                                }
                                className="serch-label"
                                sx={{ marginRight: "25px" }}
                              >
                                <Checkbox
                                  checked={addData.product_name_list.includes(
                                    productName.product_name,
                                  )}
                                  onClick={() => {
                                    let _category_id_list =
                                      addData.category_id_list.concat();
                                    let _product_name_list =
                                      addData.product_name_list.concat();
                                    if (
                                      addData.product_name_list.includes(
                                        productName.product_name,
                                      )
                                    ) {
                                      _product_name_list =
                                        _product_name_list.filter(
                                          (product_name) =>
                                            product_name !==
                                            productName.product_name,
                                        );
                                    } else {
                                      _product_name_list.push(
                                        productName.product_name,
                                      );
                                      if (
                                        !addData.category_id_list.includes(
                                          categoryName.category_id,
                                        )
                                      ) {
                                        _category_id_list.push(
                                          categoryName.category_id,
                                        );
                                      }
                                    }
                                    setAddData((addData) => ({
                                      ...addData,
                                      category_id_list: _category_id_list,
                                      product_name_list: _product_name_list,
                                    }));
                                  }}
                                  sx={{
                                    "& .MuiSvgIcon-root": { fontSize: 16 },
                                    marginTop: "-2px",
                                    marginLeft: "20px",
                                  }}
                                />
                                {productName.product_name}
                              </Box>
                            );
                          }
                        })}
                      </>
                    );
                  })}
                </Box>
              </Box>
            </Paper>
            <Box
              key="shozaiSelect"
              style={{ display: windowWidth > 385 ? "flex" : undefined }}
            >
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? undefined : "5px",
                }}
              >
                <Button
                  data-testid="tossup-add-product-next-button"
                  disabled={addData.category_id_list.length === 0}
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={async () => {
                    await getFormInfo();
                  }}
                >
                  <Box className="m-plus-rounded-1c-regular">次へ</Box>
                </Button>
              </Box>
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? "10px" : "5px",
                }}
              >
                <Button
                  data-testid="tossup-add-product-back-button"
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    swCloseModal();
                  }}
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </Box>
          </Typography>
        ) : addData.addStatus === "toss_up" ? (
          <Typography
            key="TossUpAddModalBoxContract"
            id="modal-modal-description"
            sx={{
              mt: 2,
              mb: 5,
              maxHeight: windowWidth > 385 ? undefined : "calc(70vh - 30px)",
              overflowY: windowWidth > 385 ? undefined : "auto",
            }}
          >
            <Paper elevation={0}>
              <Box
                key="contract1"
                sx={{
                  maxHeight:
                    windowWidth > 385 ? "calc(70vh - 80px)" : undefined,
                  overflowY: windowWidth > 385 ? "auto" : undefined,
                }}
              >
                <Box className="serch-label">リストID</Box>
                <Box key="serviceListIDBox">
                  <CustomTextField
                    id="textFieldIdListID"
                    size="small"
                    value={addData.customer_list_id}
                    onChange={async (e) => {
                      setAddData((addData) => ({
                        ...addData,
                        customer_list_id: e.target.value,
                      }));
                    }}
                    sx={{
                      width: "calc(100% - 10px)",
                      margin: "10px 5px",
                    }}
                  />
                  <FormHelperText
                    id="serch-name"
                    sx={{
                      width: "calc(100% - 10px)",
                      textAlign: "right",
                      marginTop: "-8px",
                      marginRight: "5px",
                      height: "25px",
                    }}
                  >
                    ※任意
                  </FormHelperText>
                </Box>
                <Box className="serch-label">架電希望日</Box>
                <Box key="hope_call_date">
                  <CustomTextField
                    id="hope_call_date"
                    size="small"
                    type="date"
                    value={addData.hope_call_date}
                    onChange={async (e) => {
                      setAddData((addData) => ({
                        ...addData,
                        hope_call_date: e.target.value,
                      }));
                    }}
                    sx={{
                      width: "calc(100% - 10px)",
                      margin: "10px 5px",
                    }}
                  />
                  <FormHelperText
                    id="serch-name"
                    sx={{
                      width: "calc(100% - 10px)",
                      textAlign: "right",
                      marginTop: "-8px",
                      marginRight: "5px",
                      height: "25px",
                    }}
                  >
                    ※必須
                  </FormHelperText>
                </Box>
                <Box className="serch-label">架電希望タイミング</Box>
                <FormControl
                  fullWidth
                  sx={{
                    marginTop: "10px",
                    marginLeft: "5px",
                    width: "calc(100% - 10px)",
                  }}
                >
                  <Select
                    labelId="serch-input-label"
                    id="serch-input-option"
                    key={"tableColumnKomokuDataSelectTiming"}
                    value={addData.hope_call_time_kind}
                    onChange={(e) => {
                      setAddData((addData) => ({
                        ...addData,
                        hope_call_time_kind: e.target.value as number,
                      }));
                    }}
                    sx={{
                      height: "30px",
                      textAlign: "end",
                      fontSize: "14px",
                    }}
                  >
                    {LIST_POST.hope_call_time_kind.map((input, i) => {
                      return (
                        <MenuItem
                          key={"tableColumnKomokuDataSelectTiming" + i}
                          value={input.id}
                          sx={{
                            fontSize: "14px",
                            height: input.value === "" ? "14px" : "24px",
                            minHeight: "auto",
                          }}
                        >
                          {input.value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText
                    id="serch-name"
                    sx={{
                      width: "calc(100% - 20px)",
                      textAlign: "right",
                      marginRight: "5px",
                      height: "25px",
                    }}
                  >
                    ※必須
                  </FormHelperText>
                </FormControl>
                {addData.hope_call_time_kind === 1 ? (
                  <>
                    <Box className="serch-label">
                      架電希望時間（ ※時間指定 ）
                    </Box>
                    <Box key="hope_call_time">
                      <FormControl
                        sx={{
                          marginTop: "10px",
                          marginBottom: "20px",
                          marginLeft: "5px",
                          width: "calc(50% - 10px)",
                        }}
                      >
                        <Select
                          labelId="serch-input-label"
                          id="serch-input-option"
                          key={"tableColumnKomokuDataSelectTiming"}
                          value={addData.hope_call_time.split("-")[0]}
                          onChange={(e) => {
                            setAddData((addData) => ({
                              ...addData,
                              hope_call_time:
                                (e.target.value as string) +
                                "-" +
                                addData.hope_call_time.split("-")[1],
                            }));
                          }}
                          sx={{
                            height: "30px",
                            textAlign: "end",
                            fontSize: "14px",
                          }}
                        >
                          {LIST.hope_call_time_hour.map((time, i) => {
                            return (
                              <MenuItem
                                key={"tableColumnKomokuDataSelectTiming" + i}
                                value={time}
                                sx={{
                                  fontSize: "14px",
                                  height: time === "" ? "14px" : "24px",
                                  minHeight: "auto",
                                }}
                              >
                                {time}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      <FormControl
                        sx={{
                          marginTop: "10px",
                          marginBottom: "20px",
                          marginLeft: "10px",
                          width: "calc(50% - 10px)",
                        }}
                      >
                        <Select
                          labelId="serch-input-label"
                          id="serch-input-option"
                          key={"tableColumnKomokuDataSelectTiming"}
                          value={addData.hope_call_time.split("-")[1]}
                          onChange={(e) => {
                            setAddData((addData) => ({
                              ...addData,
                              hope_call_time:
                                addData.hope_call_time.split("-")[0] +
                                "-" +
                                (e.target.value as string),
                            }));
                          }}
                          sx={{
                            height: "30px",
                            textAlign: "end",
                            fontSize: "14px",
                          }}
                        >
                          {LIST.hope_call_time_minute.map((time, i) => {
                            return (
                              <MenuItem
                                key={"tableColumnKomokuDataSelectTiming" + i}
                                value={time}
                                sx={{
                                  fontSize: "14px",
                                  height: time === "" ? "14px" : "24px",
                                  minHeight: "auto",
                                }}
                              >
                                {time}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Box>
                  </>
                ) : null}
                {uniqueOptinList.map((uniqueOption, option_i) => {
                  const option_selects = uniqueOption.option_select as string[];
                  const product_names = uniqueOption.product_names as string[];
                  const depend_option_name =
                    uniqueOption.depend_option_name as string;
                  const depend_select_names =
                    uniqueOption.depend_select_names as string[];
                  const depend_option_value =
                    addData.customerInfo[depend_option_name];
                  if (
                    (product_names.length === 0 ||
                      product_names.some((item) =>
                        addData.product_name_list.includes(item),
                      )) &&
                    (depend_option_name === "他質問に依存しない" ||
                      (typeof depend_option_value === "string" &&
                        depend_select_names.includes(
                          depend_option_value as string,
                        )) ||
                      (typeof depend_option_value === "object" &&
                        depend_select_names.some((item) =>
                          depend_option_value.includes(item),
                        )))
                  ) {
                    return (
                      <Box key={"optionBox_" + option_i}>
                        <Box className="serch-label">
                          {uniqueOption.option_name}
                        </Box>
                        {uniqueOption.option_type === 0 ? (
                          uniqueOption.tel_flg === 1 ? (
                            <InputFreeTextTel
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.name_flg === 1 ? (
                            <InputFreeTextName
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.zip_code_flg === 1 ? (
                            <InputFreeTextZipCode
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.space_flg === 1 ? (
                            <InputFreeTextSpace
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.mail_address_flg === 1 ? (
                            <InputFreeTextMailAddress
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : uniqueOption.form_tel_flg === 1 ? (
                            <InputFreeTextFormTel
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : (uniqueOption.half_width_number_flg || 0) === 1 ? (
                            <InputFreeTextHalfWidthNumber
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          ) : (
                            <InputFreeText
                              addData={addData}
                              setAddData={setAddData}
                              uniqueOption={uniqueOption}
                              addressOptionName={addressOptionName}
                            />
                          )
                        ) : uniqueOption.option_type === 1 ? (
                          <FormControl
                            fullWidth
                            sx={{
                              marginTop: "10px",
                              marginLeft: "5px",
                              width: "calc(100% - 10px)",
                            }}
                          >
                            <Select
                              labelId="serch-input-label"
                              id="serch-input-option"
                              key={"tableColumnKomokuDataSelect" + option_i}
                              value={
                                addData.customerInfo[
                                  uniqueOption.option_name as string
                                ]
                              }
                              onChange={(e) => {
                                let customerInfo = addData.customerInfo;
                                customerInfo[
                                  uniqueOption.option_name as string
                                ] = e.target.value as string;
                                setAddData((addData) => ({
                                  ...addData,
                                  customerInfo,
                                }));
                              }}
                              sx={{
                                height: "30px",
                                textAlign: "end",
                                fontSize: "14px",
                              }}
                            >
                              {option_selects.map(
                                (option_select: string, select_i) => {
                                  return (
                                    <MenuItem
                                      key={
                                        "tableColumnKomokuMenuItem" +
                                        option_i +
                                        "_" +
                                        select_i
                                      }
                                      value={option_select}
                                      sx={{
                                        fontSize: "14px",
                                        height:
                                          option_select === ""
                                            ? "14px"
                                            : "24px",
                                        minHeight: "auto",
                                      }}
                                    >
                                      {option_select}
                                    </MenuItem>
                                  );
                                },
                              )}
                            </Select>
                            <FormHelperText
                              id="serch-name"
                              sx={{
                                width: "calc(100% - 20px)",
                                textAlign: "right",
                                marginRight: "5px",
                                height: "25px",
                              }}
                            >
                              {uniqueOption.required_optional === 1
                                ? "※必須"
                                : "※任意"}
                            </FormHelperText>
                            {uniqueOption.option_comment !== "" ? (
                              <FormHelperText
                                id="serch-name"
                                sx={{
                                  width: "calc(100% - 20px)",
                                  textAlign: "right",
                                  marginTop: "-8px",
                                  height: "25px",
                                }}
                              >
                                {uniqueOption.option_comment}
                              </FormHelperText>
                            ) : null}
                          </FormControl>
                        ) : uniqueOption.option_type === 2 ? (
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              marginTop: "10px",
                              marginBottom: "20px",
                              marginLeft: "5px",
                              width: "calc(100% - 10px)",
                            }}
                          >
                            {option_selects.map(
                              (option_select: string, select_i) => {
                                const customerInfoList = addData.customerInfo[
                                  uniqueOption.option_name as string
                                ] as string[];
                                return (
                                  <Box
                                    key={
                                      "tableColumnKomokuDataBox" +
                                      option_i +
                                      "_" +
                                      select_i
                                    }
                                    sx={{ marginRight: "25px" }}
                                  >
                                    <Checkbox
                                      checked={
                                        customerInfoList.findIndex(
                                          (_option_select) =>
                                            _option_select === option_select,
                                        ) > -1
                                      }
                                      onClick={() => {
                                        let _customerInfoList =
                                          customerInfoList.concat();
                                        if (
                                          customerInfoList.findIndex(
                                            (_option_select) =>
                                              _option_select === option_select,
                                          ) > -1
                                        ) {
                                          _customerInfoList =
                                            _customerInfoList.filter(
                                              (_option_select) =>
                                                _option_select !==
                                                option_select,
                                            );
                                        } else {
                                          _customerInfoList.push(option_select);
                                        }
                                        let customerInfo = addData.customerInfo;
                                        customerInfo[
                                          uniqueOption.option_name as string
                                        ] = _customerInfoList;
                                        setAddData((addData) => ({
                                          ...addData,
                                          customerInfo,
                                        }));
                                      }}
                                      sx={{
                                        "& .MuiSvgIcon-root": { fontSize: 16 },
                                        marginTop: "-5px",
                                      }}
                                    />
                                    {option_select}
                                  </Box>
                                );
                              },
                            )}
                            <FormHelperText
                              id="serch-name"
                              sx={{
                                width: "calc(100% - 6px)",
                                textAlign: "right",
                                marginTop: "-2px",
                                marginRight: "5px",
                                height: "25px",
                              }}
                            >
                              {uniqueOption.required_optional === 1
                                ? "※必須"
                                : "※任意"}
                            </FormHelperText>
                            {uniqueOption.option_comment !== "" ? (
                              <FormHelperText
                                id="serch-name"
                                sx={{
                                  width: "calc(100% - 6px)",
                                  textAlign: "right",
                                  marginTop: "-8px",
                                  height: "25px",
                                }}
                              >
                                {uniqueOption.option_comment}
                              </FormHelperText>
                            ) : null}
                          </Box>
                        ) : uniqueOption.option_type === 3 ? (
                          <>
                            <CustomTextField
                              id="textFieldIdDate"
                              size="small"
                              type="date"
                              value={
                                addData.customerInfo[
                                  uniqueOption.option_name as string
                                ]
                              }
                              onChange={async (e) => {
                                let customerInfo = addData.customerInfo;
                                customerInfo[
                                  uniqueOption.option_name as string
                                ] = e.target.value;
                                setAddData((addData) => ({
                                  ...addData,
                                  customerInfo,
                                }));
                              }}
                              sx={{
                                width: "calc(100% - 10px)",
                                margin: "10px 5px",
                              }}
                            />
                            <FormHelperText
                              id="serch-name"
                              sx={{
                                width: "calc(100% - 10px)",
                                textAlign: "right",
                                marginTop: "-8px",
                                marginRight: "5px",
                                height: "25px",
                              }}
                            >
                              {uniqueOption.required_optional === 1
                                ? "※必須"
                                : "※任意"}
                            </FormHelperText>
                            {uniqueOption.option_comment !== "" ? (
                              <FormHelperText
                                id="serch-name"
                                sx={{
                                  width: "calc(100% - 10px)",
                                  textAlign: "right",
                                  marginTop: "-8px",
                                  height: "25px",
                                }}
                              >
                                {uniqueOption.option_comment}
                              </FormHelperText>
                            ) : null}
                          </>
                        ) : uniqueOption.option_type === 4 ? (
                          <>
                            <input
                              id="textFieldPicture"
                              type="file"
                              onChange={(
                                event_file: React.ChangeEvent<HTMLInputElement>,
                              ) => {
                                if (
                                  event_file.target.files &&
                                  event_file.target.files.length > 0
                                ) {
                                  const file = event_file.target.files[0];
                                  const updatedPostPictures = {
                                    ...postPictures,
                                    [uniqueOption.option_name as string]: file,
                                  };
                                  setPostPicture(updatedPostPictures);
                                }
                              }}
                            />
                            <FormHelperText
                              id="serch-name"
                              sx={{
                                width: "calc(100% - 10px)",
                                textAlign: "right",
                                marginTop: "-8px",
                                marginRight: "5px",
                                height: "25px",
                              }}
                            >
                              {uniqueOption.required_optional === 1
                                ? "※必須"
                                : "※任意"}
                            </FormHelperText>
                            {uniqueOption.option_comment !== "" ? (
                              <FormHelperText
                                id="serch-name"
                                sx={{
                                  width: "calc(100% - 10px)",
                                  textAlign: "right",
                                  marginTop: "-8px",
                                  height: "25px",
                                }}
                              >
                                {uniqueOption.option_comment}
                              </FormHelperText>
                            ) : null}
                          </>
                        ) : null}
                      </Box>
                    );
                  }
                })}
              </Box>
            </Paper>
            <Box
              key="contract7"
              style={{ display: windowWidth > 385 ? "flex" : undefined }}
            >
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? undefined : "5px",
                }}
              >
                <Button
                  data-testid="tossup-add-submit-button"
                  disabled={!onPostBottun}
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={postAddTossUpData}
                >
                  <Box
                    className="m-plus-rounded-1c-regular"
                    style={{
                      color: !onPostBottun ? "rgb(70 70 70)" : undefined,
                    }}
                  >
                    新規登録
                  </Box>
                  <AddCircleOutlineIcon
                    sx={{
                      marginLeft: "6px",
                      color: !onPostBottun ? "rgb(70 70 70)" : "white",
                    }}
                    fontSize="medium"
                  />
                </Button>
              </Box>
              <Box
                style={{
                  marginTop: "10px",
                  height: "40px",
                  width:
                    windowWidth > 385 ? "calc(50% - 5px)" : "calc(100% - 10px)",
                  marginLeft: windowWidth > 385 ? "10px" : "5px",
                }}
              >
                <Button
                  data-testid="tossup-add-final-back-button"
                  variant="contained"
                  style={{
                    height: "40px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setAddData((addData) => ({
                      ...addData,
                      addStatus: "product",
                      category_id_list: [],
                      product_name_list: [],
                      customerInfo: {},
                    }));
                    setUniqueOptinList([]);
                    setAddressOptionName("");
                  }}
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </Box>
          </Typography>
        ) : null}
      </Box>
    </Modal>
  ) : null;
}
